import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Contact from "./pages/Contact";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PendingApproval from "./pages/PendingApproval";

import Dashboard from "./pages/clinic/Dashboard";
import Catalogue from "./pages/clinic/Catalogue";
import ProductDetail from "./pages/clinic/ProductDetail";
import Cart from "./pages/clinic/Cart";
import Orders from "./pages/clinic/Orders";
import Downloads from "./pages/clinic/Downloads";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminClinics from "./pages/admin/AdminClinics";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminDownloads from "./pages/admin/AdminDownloads";
import AdminPromotions from "./pages/admin/AdminPromotions";
import AdminEvents from "./pages/admin/AdminEvents";
import ClinicEvents from "./pages/clinic/Events";

function App() {
    return (
        <AuthProvider>
            <CartProvider>
                <BrowserRouter>
                    <Toaster position="top-right" />
                    <Routes>
                        <Route path="/" element={<Navigate to="/login" replace />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/pending" element={<ProtectedRoute><PendingApproval /></ProtectedRoute>} />

                        <Route path="/dashboard" element={<ProtectedRoute role="clinic"><Dashboard /></ProtectedRoute>} />
                        <Route path="/catalogue" element={<ProtectedRoute role="clinic"><Catalogue /></ProtectedRoute>} />
                        <Route path="/catalogue/:id" element={<ProtectedRoute role="clinic"><ProductDetail /></ProtectedRoute>} />
                        <Route path="/cart" element={<ProtectedRoute role="clinic"><Cart /></ProtectedRoute>} />
                        <Route path="/orders" element={<ProtectedRoute role="clinic"><Orders /></ProtectedRoute>} />
                        <Route path="/downloads" element={<ProtectedRoute role="clinic"><Downloads /></ProtectedRoute>} />
                        <Route path="/events" element={<ProtectedRoute role="clinic"><ClinicEvents /></ProtectedRoute>} />

                        <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
                        <Route path="/admin/clinics" element={<ProtectedRoute role="admin"><AdminClinics /></ProtectedRoute>} />
                        <Route path="/admin/products" element={<ProtectedRoute role="admin"><AdminProducts /></ProtectedRoute>} />
                        <Route path="/admin/orders" element={<ProtectedRoute role="admin"><AdminOrders /></ProtectedRoute>} />
                        <Route path="/admin/downloads" element={<ProtectedRoute role="admin"><AdminDownloads /></ProtectedRoute>} />
                        <Route path="/admin/promotions" element={<ProtectedRoute role="admin"><AdminPromotions /></ProtectedRoute>} />
                        <Route path="/admin/events" element={<ProtectedRoute role="admin"><AdminEvents /></ProtectedRoute>} />

                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </BrowserRouter>
            </CartProvider>
        </AuthProvider>
    );
}

export default App;
